import { AbstractClone } from "../../abstract/clone.abstract";
import { Injectable, Injector } from "@angular/core";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";
import { CloneService } from "./clone.service";
import { WidgetsColumnModel } from "src/app/models/widgets/widgets-column.model";
import { WidgetsContainerAbstract } from "src/app/abstract/widgets/widgets-container.abstract";

@Injectable({
  providedIn: 'root'
})
export class CloneColumnService extends AbstractClone {

  constructor(private injector: Injector) {
    super();
  }

  cloneFromJS(origWidget: any,
    destWidget: WidgetsAbstract,
    isDragNDrop: boolean,
    isInsideQuestion: boolean,
    parentId: string | undefined) {
    // Retrieve from injector to avoid circular dependency
    const widgetsCloneService = this.injector.get(CloneService);

    // Cloning from JSON to TypeScript
    const origColumn = origWidget as WidgetsColumnModel;
    const newColumn = new WidgetsColumnModel();
    newColumn.cloneFrom(origColumn);
    newColumn.parentId = parentId;
    // newColumn.width = origColumn.width;

    const parentContainer = destWidget as WidgetsContainerAbstract;
    parentContainer.children.push(newColumn);
    if (origColumn.children) {
      origColumn.children.forEach(childWidget => {
        widgetsCloneService.cloneFromJS(childWidget, newColumn, isDragNDrop, isInsideQuestion, newColumn.id);
      });
    }
  }
}
